import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { Container, Grid } from "@material-ui/core";
import { LocalStorageService, ClientContractService, RevisionClientContractService, TemplateService } from "../../../services";
import { DocumentEditorContainerComponent, SfdtExport, Selection, Editor, WordExport, Print, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import { PromotionalFooterPure, DialogSystemGLPure, DialogFormHLPure, ConfirmationDataModal } from "../../pures";
import axios from "axios";

import './edit-docx.css'

DocumentEditorContainerComponent.Inject(SfdtExport, Selection, Editor, WordExport, Print, Toolbar)


/**
 * @author Brayan Salas
 * @description Component to use Syncfusion and Edit Docx files
 * @param {*} props
 * @param props.location.state (enableTrackChangesGovo Boolean, type String ej: 'inboxTypeClientContract')
 * @return {*} 
 */
const EditDocx = (props) => {
  useEffect(() => {
    localStorage.setItem('currentUrl', props.history.location.pathname)
    if (props.location.state.type !== 'template') window.addEventListener('beforeunload', () => { clientContractService.setIsOpenClientContract(Number(clientContractId), false, token) })

    return (
      window.removeEventListener('beforeunload', () => { })
    )
  }, [])

  let confirmation = {
    questionnaires: [],
    variablesDeleted: [],
    variablesAdded: []
  }
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [showDialogEdit, setShowDialogEdit] = useState(false)
  const [confirmationData, setConfirmationData] = useState(confirmation)
  const [templateData, setTemplateData] = useState({})
  const [clicExit, setClicExit] = useState(false)

  const localStorageService = new LocalStorageService();
  const clientContractService = new ClientContractService(process.env.REACT_APP_MIFIRMA_API)
  const revisionClientContractService = new RevisionClientContractService(process.env.REACT_APP_MIFIRMA_API)
  let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);

  const token = localStorageService.getLocalStorageItem("token").idToken;
  let { clientContractId } = useParams()
  if (props.location.state.type !== 'template') localStorage.setItem('clientContractId', clientContractId)

  // The editor object is the property that loads the Syncfusion Editor Document Container and all his actions (Example: Open file)
  let editorObj = useRef(null)

  // Functions to handle modal loading and success
  const finishHandleFile = () => {
    setLoading(false)
    setSuccess(true)
  }

  const hideSuccess = () => { setSuccess(false) }

  const comebackPage = async (clientContractId) => {
    let inbox
    if (props.location.state) {
      if ([true, false].includes(props.location.state.trackChangesGovo)) {
        inbox = await clientContractService.getInboxByClientContractId(clientContractId, props.location.state.type, token)
        props.history.push(`/${inbox.data.solicitudeUrl}?mode=dk`)
      }
    } else {
      props.history.push('/')
    }

    return inbox
  }

  /**
   * @author Brayan Salas
   * @description Method to save file in AWS
   * @param {*} contract
   * @param {*} editorObj
   * @param {boolean} [exit=false]
   */
  const saveFileAWS = async (contract, editorObj, exit, revisions) => {
    editorObj.documentEditor.saveAsBlob('Docx').then(async exportedDocument => {
      setLoading(true)
      if (props.location.state.type === "inboxTypeNegotiation") {
        await saveTrackChanges(editorObj, true, revisions)
        await stopProtection(editorObj)
      }

      let ajax = new XMLHttpRequest();
      ajax.open('POST', process.env.REACT_APP_SYNCFUSION_API + 'SaveAWS', true);
      ajax.onreadystatechange = () => {
        if (ajax.readyState === 4) {
          if (props.location.state.type === "inboxTypeNegotiation") clientContractService.setIsOpenClientContract(Number(clientContractId), false, token)
          if (ajax.status === 200 || ajax.status === 304) {
            finishHandleFile()

            setTimeout(() => {
              hideSuccess()
              if (exit) comebackPage(contract.id)
              if (props.location.state.type === "inboxTypeNegotiation") enableTrackChanges(editorObj, props.location.state.trackChangesGovo)
            }, 2000)
          } else {
            // If syncfusion backend doesn't response
            setError(true)
            setTimeout(() => {
              setError(false)
            }, 4000)
          }
        }
      };
      let formData = new FormData();
      formData.append('files', exportedDocument);
      formData.append('contractName', contract.name);
      formData.append('contractId', contract.id);
      formData.append('token', token);

      ajax.send(formData);
    });
  }

  /**
   * @author Brayan Salas
   * @description Method to load file in Syncfusion Editor
   * @param {*} file
   * @param {*} editorObj
   */
  const loadFile = async (file, editorObj) => {
    let ajax = new XMLHttpRequest();
    ajax.open('POST', process.env.REACT_APP_SYNCFUSION_API + 'Import', true);
    ajax.onreadystatechange = () => {
      if (ajax.readyState === 4) {
        if (ajax.status === 200 || ajax.status === 304) {
          // open SFDT text in document editor
          editorObj.documentEditor.open(ajax.responseText);
        } else {
          // If syncfusion backend doesn't response
          setError(true)
          if (props.location.state.type === "inboxTypeNegotiation") clientContractService.setIsOpenClientContract(Number(clientContractId), false, token)
        }
      }
    };
    let formData = new FormData();
    formData.append('files', file);
    ajax.send(formData);
  }

  /**
   * @author Brayan Salas
   * @description Method to initiliaze Syncfusion with the Document path
   * @param {*} editorObj
   */
  const initDocumentAndConfig = async (editorObj) => {
    if (editorObj) {
      if (props.location.state) {
        if ([true, false].includes(props.location.state.trackChangesGovo)) {
          let url = ''
          let contract = {}
          if (props.location.state.type === 'template') {
            contract = await templateService.getTEmplateFile(clientContractId, token)
            url = (contract && contract.data && contract.data.temporalPathWord) ? contract.data.temporalPathWord : ''
            setTemplateData(contract)
          } else {
            contract = await clientContractService.getContractById(clientContractId, token)
            url = contract.data.updatedDocumentPathWord
          }
          let file = await axios({ url: url, method: 'GET', responseType: 'blob' })
          file = file.data

          await loadFile(file, editorObj)
          if (props.location.state.trackChangesGovo) {
            setTimeout(async () => {
              // Set true or false enableTrackChanges
              await enableTrackChanges(editorObj, props.location.state.trackChangesGovo)
              let revisions = await saveRevisions(editorObj)

              // To handle custom toolbar click event.
              editorObj.toolbarClick = (args) => {
                console.log(args)
                switch (args.item.id) {
                  case 'save-aws':
                    saveFileAWS(contract.data, editorObj, false, revisions)
                    break;
                  case 'save-close':
                    saveFileAWS(contract.data, editorObj, true, revisions)
                    break;
                  case 'goBack':
                    props.history.goBack()
                    break;
                }
              }
            }, 2000)
          } else {
            // To handle custom toolbar click event.
            editorObj.toolbarClick = (args) => {
              console.log(args)
              switch (args.item.id) {
                case 'save-aws':
                  saveFileAWS(contract.data, editorObj, false)
                  break;
                case 'save-close':
                  saveFileAWS(contract.data, editorObj, true)
                  break;
                case 'goBack':
                  props.history.goBack()
                  break;
                case 'save-template-aws':
                  saveFileTemplateAWS(contract.data, editorObj, false)
                  break;
                case 'save-template-close':
                  saveFileTemplateAWS(contract.data, editorObj, true)
                  break;
              }
            }
            setLoading(false)
          }
        }
      } else {
        comebackPage(clientContractId)
      }
    }
  }

  /**
   * @author Brayan Salas
   * @description Save revisions found in syncfusion in state
   * @param {*} editorObj
   * @return {*} 
   */
  const saveRevisions = async (editorObj, saveState = true) => {

    let trackingChanges = []

    // Si hay cambios...
    if (editorObj.documentEditor.revisions
      && editorObj.documentEditor.revisions.changes
      && editorObj.documentEditor.revisions.changes.length !== 0) {
      let revisions = editorObj.documentEditor.revisions

      // Obtener los cambios
      revisions.changes.map((revision) => {
        let userId = 0

        let auth0User = JSON.parse(localStorage.getItem('user')).userMetaData.userA3Cloud
        if (`${auth0User.firstName} ${auth0User.firstLastName}` === revision.author) {
          userId = JSON.parse(localStorage.getItem('user')).userMetaData.userMifirma.id
        }

        if (revision.revisionType === 'Deletion') {
          let stringDeleted = ""
          revision.range.map((char) => {
            stringDeleted = stringDeleted = stringDeleted + char.text
          })

          let trackingChange = {
            revisionId: revision.revisionID,
            workflowExecutionId: props.location.state.workflowExecutionId,
            text: stringDeleted,
            type: revision.revisionType,
            createdDate: revision.date
          }

          if (userId) trackingChange['userId'] = userId
          trackingChanges.push(trackingChange)
        } else {
          let stringAdded = ""
          revision.range.map((sentence) => {
            if (sentence.text) {
              stringAdded = stringAdded = stringAdded + sentence.text
            } else {
              stringAdded = stringAdded + ' \n' // Agregamos salto de linea
            }
          })

          let trackingChange = {
            revisionId: revision.revisionID,
            workflowExecutionId: props.location.state.workflowExecutionId,
            text: stringAdded,
            type: revision.revisionType,
            createdDate: revision.date
          }

          if (userId) trackingChange['userId'] = userId
          trackingChanges.push(trackingChange)
        }
      })

      console.log(trackingChanges, 'objeto final...')
      // if (saveState) {
      //   console.log('guardar en revisions initial')
      //   setRevisions(trackingChanges)
      // }
    }
    return trackingChanges
  }

  /**
   * @author Brayan Salas
   * @description Method to get changes in the document opened
   * @param {*} editorObj
   * @return {*} 
   */
  const getChangesInDocument = (editorObj) => {
    let revisions = editorObj.documentEditor.revisions
    console.log(revisions)

    if (revisions.owner.editorHistoryModule.undoStackIn) {
      let changesChecked = []

      revisions.owner.editorHistoryModule.undoStackIn.map((changeChecked) => {
        console.log(typeof changeChecked.removedNodesIn[0], typeof changeChecked.removedNodesIn[0] == 'object')
        if (changeChecked.removedNodesIn.length !== 0 && typeof changeChecked.removedNodesIn[0] == 'string') { // id directo
          changesChecked.push({ id: changeChecked.removedNodesIn[0], action: changeChecked.actionIn })
        } else if (changeChecked.removedNodesIn.length !== 0 && typeof changeChecked.removedNodesIn[0] == 'object') { // id dentro de un objecto
          let flag = false
          changeChecked.removedNodesIn.map((sentence) => {
            if (sentence.removedIds && sentence.removedIds.length !== 0 && !flag) {
              flag = true
              changesChecked.push({ id: sentence.removedIds[0], action: changeChecked.actionIn })
            }
          })
        }
      })

      return changesChecked
    }
  }

  /**
   * @author Brayan Salas
   * @description Method to get status from truth tables found in syncfusion information
   * @param {*} type
   * @param {*} action
   * @return {*} 
   */
  const getStatusFromTruthTableSync = (type, action) => {
    if (
      (type === 'Deletion' && action === 'Accept Change') ||
      (type === 'Insertion' && action === 'ClearRevisions')) {
      return 'accepted'
    } else if (
      (type === 'Deletion' && action === 'ClearRevisions') ||
      (type === 'Insertion' && action === 'Reject Change') ||
      (type === 'Insertion' && action === 'BackSpace')
    ) {
      return 'rejected'
    } else {
      return 'pending'
    }
  }

  /**
   * @author Brayan Salas
   * @description Method to verify the recently object status get in saveRevisions
   * @param {*} editorObj
   */
  const saveTrackChanges = async (editorObj, save, revisions) => {
    let revisionsInitial = revisions.map((revision) => revision)
    let revisionsAux = await saveRevisions(editorObj, false)

    // Hay que verificar que el inicial sea mayor al revisionsAux
    revisionsInitial.map((revInitial) => {
      // Validate if exists a revision
      let existsRevision = revisionsAux.filter((revAux) => revAux.createdDate === revInitial.createdDate)

      // Si no existe agrega su informacion
      if (existsRevision.length === 0) {
        revisionsAux.push(revInitial)
      } else {
        // Si ya existe actualiza su nueva informacion por si acaso
        revInitial.text = existsRevision.text
        revInitial.changeAccepted = existsRevision.changeAccepted
      }
    })

    // Cambios en ciertos ids encontrados
    let changesChecked = getChangesInDocument(editorObj)

    // Validate changes that were accepted and rejected or pending
    if (changesChecked && changesChecked.length !== 0) {
      revisionsAux.map((revision) => {

        let { revisionId, type } = revision
        let selectedChange = changesChecked.filter((change) => (change.id === revisionId))

        let backSpaceQuantity = 0
        changesChecked.map((change) => {
          if (change.id === revisionId && change.action === 'BackSpace') {
            backSpaceQuantity = backSpaceQuantity + 1
          }
        })

        let status = 'pending'
        if (selectedChange.length !== 0 && backSpaceQuantity <= 1) status = getStatusFromTruthTableSync(type, selectedChange[0].action) // accepted, rejected, pending...

        revision['changeAccepted'] = status
      })
    } else {
      revisionsAux.map((revision) => {

        revision['changeAccepted'] = 'pending'
      })
    }

    console.log(revisionsAux, 'nuevas')
    save && await revisionClientContractService.insertRevisionsClientDocument(revisionsAux, token)
  }

  // Set true or false enableTrackChanges
  const enableTrackChanges = async (editorObj, value) => {
    if (editorObj) {
      if (value && props.location.state.userHasTrackChanges && props.location.state.type === "inboxTypeNegotiation") {
        await stopProtection(editorObj)
      } else {
        await enforceProtection(editorObj)
      }

      setTimeout(() => {
        editorObj['enableTrackChanges'] = value
        console.log(editorObj.enableTrackChanges, editorObj, '...')
        setLoading(false)
      }, 1000)
    }
  }

  let enforceProtection = async (editorObj) => {
    console.log("enforce protection")
    //enforce protection
    await editorObj.documentEditor.editor.enforceProtection('123', 'TrackChanges');
  }

  let stopProtection = async (editorObj) => {
    console.log('stop protection')
    //stop the document protection
    await editorObj.documentEditor.editor.stopProtection('123');
  }

  useEffect(() => {
    initDocumentAndConfig(editorObj.current)
  }, [editorObj])


  // Custom toolbar item.
  let saveItem = {
    prefixIcon: "e-save",
    tooltipText: "Save Document",
    text: "Save",
    id: (props.location.state.type === 'template') ? "save-template-aws" : "save-aws",
  };

  let saveAndCloseItem = {
    prefixIcon: "e-save",
    tooltipText: "Save document and close",
    text: "Save and Close",
    id: (props.location.state.type === 'template') ? "save-template-close" : "save-close",
  };

  let goBack = {
    prefixIcon: "e-home",
    tooltipText: "Go back to Negotiation",
    text: "Go Back",
    id: "goBack",
  };

  // Toolbar items that allows to show Syncfusion bar.
  let items = [
    'TrackChanges', 'Separator', 'Undo', 'Redo', 'Separator', 'Image', 'Table', 'Hyperlink', 'TableOfContents', 'Separator', 'Header', 'Footer', 'PageSetup', 'PageNumber', 'Break', 'InsertFootnote', 'InsertEndnote', 'Separator', 'Find', 'Separator', 'Comments', 'Separator', saveItem, saveAndCloseItem, goBack
  ];

  // Enabled track changes logic
  let trackChangesEnabled = false
  if (props.location.state && [true, false].includes(props.location.state.trackChangesGovo)) trackChangesEnabled = props.location.state.trackChangesGovo

  // User to identify the track changes
  let user = JSON.parse(localStorage.getItem('user')).userMetaData.userA3Cloud

  /**
  * @author Edgar Escobedo
  * @description Method to save templaye file in AWS
  * @param {*} contract
  * @param {*} editorObj
  * @param {boolean} [exit=false]
  */
  const saveFileTemplateAWS = async (contract, editorObj, exit, modificationConfirmed) => {
    editorObj.documentEditor.saveAsBlob('Docx').then(async exportedDocument => {
      setLoading(true)
      //Call .NET to change word en return path of document was save in local
      let ajax = new XMLHttpRequest();
      ajax.open('POST', process.env.REACT_APP_SYNCFUSION_API + 'SaveTemplateAWS', true);
      ajax.onreadystatechange = async () => {
        if (ajax.readyState === 4) {
          if (ajax.status === 200 || ajax.status === 304) {
            //Call MiFirma API to verify if change vars, get template from local, change template n AWS and save in BD
            let pathUpdated = (ajax.response) ? ajax.response : ''
            let updateTemplayePathInMIFirmaAPI = await templateService.syncFusionUpdateTemplate(contract.id, pathUpdated, token, modificationConfirmed)
            if (updateTemplayePathInMIFirmaAPI && updateTemplayePathInMIFirmaAPI.data && Number(updateTemplayePathInMIFirmaAPI.statusCode) === 200) {
              if (updateTemplayePathInMIFirmaAPI.data.confirmChangeTemplate) {
                setConfirmationData(updateTemplayePathInMIFirmaAPI.data.confirmationData)
                if (exit) setClicExit(true)
                setLoading(false)
                setShowDialogEdit(true)
              } else {
                finishHandleFile()
                setTimeout(() => {
                  hideSuccess()
                  if (exit) props.history.goBack()
                }, 3000)
              }
            } else {
              setLoading(false)
              setError(true)
              setTimeout(() => {
                setError(false)
              }, 4000)
            }
          } else {
            // If syncfusion backend doesn't response
            setLoading(false)
            setError(true)
            setTimeout(() => {
              setError(false)
            }, 4000)
          }
        }
      };
      let formData = new FormData();
      formData.append('files', exportedDocument);
      formData.append('templateName', contract.name);
      formData.append('templateId', contract.id);
      formData.append('token', token);

      ajax.send(formData);
    });
  }

  const closeDialogConfirmation = () => {
    setClicExit(false)
    setShowDialogEdit(false)
  }

  const handleConfirmTemplate = () => {
    setShowDialogEdit(false)
    setLoading(true)
    saveFileTemplateAWS(templateData.data, editorObj.current, clicExit, true)
  }

  return (
    <div>
      <Grid
        lg={12}
        md={12}
        spacing={4}
        className="edit-docx-container"
      >
        <DocumentEditorContainerComponent
          height='90vh'
          width={
            window.innerWidth >= 1509 ? '185vh' :
              window.innerWidth >= 1466 && window.innerWidth < 1509 ? '175vh' :
                window.innerWidth >= 1426 && window.innerWidth < 1466 ? '165vh' :
                  window.innerWidth >= 1386 && window.innerWidth < 1426 ? '160vh' :
                    window.innerWidth >= 1306 && window.innerWidth < 1386 ? '155vh' :
                      // window.innerWidth >= 1306 && window.innerWidth < 1346 ? '155vh' :
                      window.innerWidth >= 1266 && window.innerWidth < 1306 ? '150vh' :
                        window.innerWidth >= 1226 && window.innerWidth < 1266 ? '140vh' :
                          window.innerWidth >= 1186 && window.innerWidth < 1226 ? '135vh' :
                            window.innerWidth >= 1126 && window.innerWidth < 1186 ? '130vh' :
                              // window.innerWidth >= 1126 && window.innerWidth < 1146 ? '130vh' :
                              '120vh'}
          id="container"
          ref={editorObj}
          serviceUrl={process.env.REACT_APP_SYNCFUSION_API} // URL del API
          toolbarItems={items}
          isReadOnly={false}
          enableEditor={true}
          enablePrint={true}
          enableSfdtExport={true}
          enableTextExport={true}
          enableWordExport={true}
          documentChange={e => { console.log('Prueba de trigger', e); }}
          enableTrackChanges={trackChangesEnabled} //habilitar la vista de cambios.
          showRevisions={trackChangesEnabled} //Muestra los cambios de revisión en el documento 
          currentUser={trackChangesEnabled ? `${user.firstName} ${user.firstLastName}` : 'Sin usuario'} //recibe el nombre del usuario.
        />
        {/* <Grid item lg={12} md={12} sm={12} xs={12}>
          <PromotionalFooterPure />
        </Grid> */}
      </Grid >
      {/* )} */}
      <DialogSystemGLPure
        showLoadingRequesting={loading}
        showCompletedRequesting={success}
        showErrorRequesting={error}
        toggleErrorRequesting={() => { setError(false) }}
        toggleLoadingRequesting={() => { setLoading(false) }}
      />
      {document.getElementsByClassName('e-toolbar-item e-de-toolbar-btn-start') && document.getElementsByClassName('e-toolbar-item e-de-toolbar-btn-start')[0] ?
        [...document.getElementsByClassName("e-toolbar-item e-de-toolbar-btn-start")].map(n => n && n.remove()) : null}

      {showDialogEdit &&
        <ConfirmationDataModal
          submit={() => closeDialogConfirmation()}
          confirmationData={confirmationData}
          cancel={() => handleConfirmTemplate()}
          customStylesCancelButton={{ marginRight: 10 }}
        />
      }

    </div >
  )
}


export default EditDocx